import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';
import { Button, ButtonGroup } from 'reactstrap';

import 'echarts/lib/chart/pie';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';

const pie_name = ['Sex', 'Age', 'Group type', 'Location', 'Season'];
const pie_data = [
  [{ value: 676, name: 'Male' }, { value: 402, name: 'Female' }],
  [{ value: 91, name: '< 19' }, { value: 415, name: '19-35' }, { value: 477, name: '36-60' }, { value: 95, name: '> 60' }],
  [{ value: 39, name: 'Farmers' }, { value: 967, name: 'Herders' }, { value: 30, name: 'Diaspora children' }, { value: 22, name: 'Students' }, { value: 20, name: 'Other' }],
  [{ value: 40, name: 'Hezuo city' }, { value: 11, name: 'Lintan county' }, { value: 18, name: 'Zhuoni county' }, { value: 672, name: 'Maqu county' }, { value: 188, name: 'Luqu county' }, { value: 149, name: 'Xiahe county' }],
  [{ value: 185, name: 'Spring' }, { value: 415, name: 'Summer' }, { value: 309, name: 'Autumn' }, { value: 169, name: 'Winter' }]
];

class PieChart extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      selectedButton: 0
    };
    this.setSelectedButton = this.setSelectedButton.bind(this);
  }

  setSelectedButton(select) {
    this.myChart.setOption({
      series: [
        {
          name: pie_data[select],
          data: pie_data[select],
        }
      ]
    });
    this.setState({
      selectedButton: select
    });
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = echarts.init(document.getElementById('pie-chart'), 'customColorTheme', 'EN');
    var option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        orient: 'horizontal',
        left: 'center',
        top: 'top',
      },
      series: [
        {
          name: pie_name[this.state.selectedButton],
          type: 'pie',
          radius: '66%',
          data: pie_data[this.state.selectedButton],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    this.myChart.setOption(option);
  }
  render() {
    return (
      <>
        <div class="d-flex justify-content-center" style={{ marginBottom: '25px'}}>
          <ButtonGroup>
            <Button outline onClick={() => this.setSelectedButton(0)} active={this.state.selectedButton === 0}>Sex</Button>
            <Button outline onClick={() => this.setSelectedButton(1)} active={this.state.selectedButton === 1}>Age</Button>
            <Button outline onClick={() => this.setSelectedButton(2)} active={this.state.selectedButton === 2}>Group type</Button>
            <Button outline onClick={() => this.setSelectedButton(3)} active={this.state.selectedButton === 3}>Location</Button>
            <Button outline onClick={() => this.setSelectedButton(4)} active={this.state.selectedButton === 4}>Season</Button>
          </ButtonGroup>
        </div>
        <div class="m-auto" id="pie-chart" style={{ height: '350px' }}></div>
      </>
    );
  }
}

export default PieChart;